const Sidebar = {
    title: 'Portofolio Saya',
    myName: 'Ryan Afrizal',
    button: [
        {
            name: 'Home',
            to: '/'
        },
        {
            name: 'Skill',
            to: '/skill'
        },
        {
            name: 'Project Saya',
            to: '/project'
        }
    ]
}

export default Sidebar